import template from './commercial-class.jade';
import allItems, { itemsByCategory } from '../../../enums/commercial-class-type';

export default angular
    .module('cian.addForm.commercialClass', [])
    .directive('cianAfAboutBuildingCommercialClass', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', 'categoryService', 'adStateService', 'deviceService', function ($scope, categoryService, adStateService, deviceService) {
          this.isMobile = deviceService.isMobile;

          $scope.$watch(() => this.ad.category, category => {
              const objectType = categoryService.getInfoByCategory(category).objectType;
              const categoryConfig = itemsByCategory[objectType] || itemsByCategory.default;

              this.options = categoryConfig.items
                  .map(item => allItems.find(option => option.value === item))
                  .filter(item => !!item);

              // очищаем при смене категории
              if (this.ad.building && this.ad.building.classType && !categoryConfig.items.includes(this.ad.building.classType)) {
                  this.ad.building.classType = undefined;
              }
          });

        }],
        controllerAs: 'commercialClass',
        template,
    }))
    .name;
